import { Component } from '@angular/core';

/**
 * Content region of `upp-panel`. Fills remaining height and stretches visible projected children.
 */
@Component({
    selector: 'upp-panel-content',
    templateUrl: './upp-content.html',
    styleUrls: ['./upp-content.scss'],
})
export class UppPanelContentComponent {
    // nothing to do
}
